import APIconsume from 'Main/APIconsume'

const BASE_URL = '/api/dashboard/security'

class SecurityService {
  constructor () {
    this._apiConsume = new APIconsume()
  }

  async getOverview (hours = 24) {
    const params = new URLSearchParams({ hours: String(hours) }).toString()
    const result = await this._apiConsume.getData(`${BASE_URL}/overview?${params}`)
    return result?.data
  }

  async getEvents ({
    page = 1,
    size = 25,
    severity = '',
    attackType = '',
    sourceIp = '',
    from = '',
    to = ''
  } = {}) {
    const params = new URLSearchParams({
      page: String(page),
      size: String(size),
      severity,
      attack_type: attackType,
      source_ip: sourceIp,
      from,
      to
    }).toString()
    const result = await this._apiConsume.getData(`${BASE_URL}/events?${params}`)
    return result?.data
  }

  async getEvent (id) {
    const result = await this._apiConsume.getData(`${BASE_URL}/events/${encodeURIComponent(id)}`)
    return result?.data
  }
}

export default SecurityService
